import { PERMISSIONS } from "@core/constants/permissions.constants";

export interface ReportFilter {
  type: 'text' | 'date-range' | 'dropdown' | 'single-date';
  field: string;
  label: string;
  placeholder: string;
  options?: { label: string; value: string | number }[];
  multiselect?: boolean;
  required?: boolean;
  width?: 'md' | 'lg' | 'xl' | 'xxl';
}

export interface ReportColumn {
  field: string;
  header: string;
  type?: 'text' | 'number';
  pipes?: string[];
  /** CSS width for table column alignment (e.g. `18%`, `120px`). Use % so skeleton and data rows match. */
  width?: string;
}

export interface ReportPermissions {
  view?: string;
  export?: string;
}

export interface ReportConfig {
  id: string;
  title: string;
  filters: ReportFilter[];
  columns: ReportColumn[];
  permissions?: ReportPermissions;
}

export const SPARE_PARTS_REPORT_CONFIG: ReportConfig = {
  id: 'spare-parts',
  title: 'Spare Parts Report',
    permissions: {
      view: PERMISSIONS.GSE.REPORTS.SPARE_PART.VIEW,
      export: PERMISSIONS.GSE.REPORTS.SPARE_PART.EXPORT,
    },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'dropdown',
      field: 'sparePartCategory',
      label: 'Spare Part Category',
      placeholder: 'Category',
    },
    {
      type: 'dropdown',
      field: 'sparePartBrand',
      label: 'Spare Part Brand',
      placeholder: 'Brand',
    },
  ],

  // 🔹 Table columns
  columns: [
    {
      field: 'sparePartName',
      header: 'Spare Part',
      type: 'text',
      width: '22%',
    },
    {
      field: 'category',
      header: 'Category',
      type: 'text',
      width: '16%',
    },
    {
      field: 'brand',
      header: 'Brand',
      type: 'text',
      width: '14%',
    },
    {
      field: 'modelNumber',
      header: 'Model Number',
      type: 'text',
      width: '14%',
    },
    {
      field: 'currentStock',
      header: 'Current Stock',
      type: 'number',
      width: '10%',
    },
    {
      field: 'minQty',
      header: 'Min. Qty',
      type: 'number',
      width: '10%',
    },
    {
      field: 'usage',
      header: 'Usage (%)',
      type: 'number',
      width: '14%',
    },
  ],
};
